import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { message } from 'antd';
import apiRequest from '../util/apiRequest';
import { shouldCheckMessages } from '../actions/ui';

const Messages = () => {
    const [isFirstRender, setIsFirstRender] = useState(true);
    const { checkMessages } = useSelector(state => state.ui);
    const dispatch = useDispatch();
    const fetchMessages = async () => {
        const response = await apiRequest.get('/api/v3/messages/');
        const payload = response.data;
        if (payload.status === 200) {
            payload.result.forEach(m => {
                if (m.level === 'debug') {
                    console.log(m.content);
                } else {
                    message[m.level](m.content, 5);
                }
            });
        }
    };

    useEffect(() => {
        if (isFirstRender || checkMessages) {
            setIsFirstRender(false);
            dispatch(shouldCheckMessages(false));
            fetchMessages();
        }
    }, [dispatch, checkMessages, isFirstRender]);

    return null;
};

export default Messages;
